export * from './delete-extra-vereinbarung.command.module';
export * from './component';
export * from './service';